import React, { useContext, useEffect, useState } from "react";
import Cards from "./Cards/Cards";
import "./charts.css";
import Vertical from "./Vertical/Vertical";
import axios from "axios";
import { Context } from "../../context/Context";
import Stats from "./Stats/Stats";

const Charts = () => {
  const [reservations, setReservations] = useState([]);
  const { user, token } = useContext(Context);

  useEffect(() => {
    const getReservations = async () => {
      const role = user.role;
      console.log(role);
      if (role === "admin") {
        const res = await axios.get(
          `https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/admin`,
          {
            headers: {
              authorization: "megaparkingIGHERQHIGQRE " + token,
            },
          }
        );
        setReservations(res.data);
      } else if (role === "agent") {
        const res = await axios.post(
          `https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/agent`,
          { agent: user.username, role: role },
          {
            headers: {
              authorization: "megaparkingIGHERQHIGQRE " + token,
            },
          }
        );
        setReservations(res.data);
      }
    };
    getReservations();
  }, [user?.agent, user?.role, user?.username, token]);

  return (
    <>
      <div className="charts">
        <div className="cards">
          <Cards reservations={reservations} />
        </div>
        <div className="stats">
          <Stats />
          <Vertical reservations={reservations} />
        </div>
      </div>
    </>
  );
};

export default Charts;
